<template>
  <div class="series-side-sheet-content">
    <SeriesPackList
      :series="series"
      :loading="!showSeriesPackList"
      skeletonBackground="rgba(0, 0, 0, 0.2)"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import SeriesPackList from '@/series/components/series-pack-list';

export default defineComponent({
  name: 'SeriesSideSheetContent',

  /**
   * 属性
   */
  props: {
    series: Object,
  },

  /**
   * 数据
   */
  data() {
    return {
      showSeriesPackList: false,
    };
  },

  /**
   * 计算属性
   */
  computed: {},

  /**
   * 已创建
   */
  created() {
    //
    setTimeout(() => {
      this.showSeriesPackList = true;
    }, 100);
  },

  /**
   * 组件方法
   */
  methods: {},

  /**
   * 使用组件
   */
  components: {
    SeriesPackList,
  },
});
</script>

<style scoped>
@import './styles/series-side-sheet-content.css';
</style>
